import React from 'react';
import InicioConcurso from '../../components/InicioConcurso';

const InicioConcursoPage = () => <InicioConcurso />;

export default InicioConcursoPage;
